import React, { useState, useEffect, useMemo } from 'react';
import api from './api';
import { useNavigate } from 'react-router-dom';

const AutoDept = () => {
  const navigate = useNavigate();
  const LOW_STOCK_LIMIT = 200;

  const [stock, setStock] = useState([]);
  const [history, setHistory] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard'); 
  
  // --- NEW: SEARCH STATE ---
  const [searchNum, setSearchNum] = useState('');
  const [searchPct, setSearchPct] = useState('');

  // Form State
  const [form, setForm] = useState({
      type: 'OUT', 
      number: '',      
      percentage: '',  
      quantity: '',
      personName: 'Bikram', 
      department: 'Auto Bottom' 
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
        const [resStock, resHistory] = await Promise.all([
            api.get('/auto/stock'),
            api.get('/auto/history')
        ]);
        setStock(resStock.data);
        setHistory(resHistory.data);
    } catch (err) { console.error(err); }
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      if (!form.number || !form.percentage || !form.quantity || !form.personName) {
          alert("Please fill all fields");
          return;
      }

      try {
          await api.post('/auto/transaction', form);
          alert("Transaction Saved!");
          setForm({ ...form, quantity: '', personName: 'Bikram' });
          fetchData(); 
      } catch (err) {
          alert("Error: " + (err.response?.data?.error || err.message));
      }
  };

  const selectItem = (item) => {
      setForm({ ...form, number: item.number, percentage: item.percentage });
      window.scrollTo(0,0);
  };

  // --- NEW: FILTER LOGIC ---
  const filteredStock = useMemo(() => {
      return stock.filter(item => {
          const matchNum = searchNum ? String(item.number).includes(searchNum) : true;
          const matchPct = searchPct ? String(item.percentage).includes(searchPct) : true;
          return matchNum && matchPct;
      });
  }, [stock, searchNum, searchPct]);

  const filteredHistory = useMemo(() => {
      return history.filter(h => {
          const num = h.diaId ? String(h.diaId.number) : '';
          const pct = h.diaId ? String(h.diaId.percentage) : '';
          const matchNum = searchNum ? num.includes(searchNum) : true;
          const matchPct = searchPct ? pct.includes(searchPct) : true;
          return matchNum && matchPct;
      });
  }, [history, searchNum, searchPct]);

  return (
    <div className="container mt-4 mb-5">
      
      <style>
        {`
            .navbar { display: none !important; } 
            .container { margin-top: 20px !important; }
        `}
      </style>

      <div className="d-flex justify-content-center align-items-center mb-4">
          <h2 className="text-primary fw-bold">⚙️ Auto Dept: Dia Tools</h2>
      </div>

      {/* TRANSACTION FORM */}
      <div className="card shadow-sm p-4 border-primary mb-5">
          <h5 className="mb-3 text-dark fw-bold border-bottom pb-2">
              {form.type === 'IN' ? '➕ Add Stock (Purchase)' : '➖ Issue to Worker'}
          </h5>
          
          <form onSubmit={handleSubmit}>
              <div className="row g-3">
                  <div className="col-12 mb-2">
                      <div className="btn-group w-100" role="group">
                          <input type="radio" className="btn-check" name="type" id="tOut" checked={form.type === 'OUT'} onChange={() => setForm({...form, type: 'OUT', department: 'Auto Bottom'})} />
                          <label className="btn btn-outline-danger fw-bold" htmlFor="tOut">📤 ISSUE (OUT)</label>

                          <input type="radio" className="btn-check" name="type" id="tIn" checked={form.type === 'IN'} onChange={() => setForm({...form, type: 'IN', department: 'Store'})} />
                          <label className="btn btn-outline-success fw-bold" htmlFor="tIn">📥 PURCHASE (IN)</label>
                      </div>
                  </div>

                  <div className="col-md-2">
                      <label className="form-label">Number</label>
                      <input className="form-control" placeholder="e.g. 1, 2, 6" value={form.number} onChange={e => setForm({...form, number: e.target.value})} list="numOptions" required />
                      <datalist id="numOptions">
                          {[...new Set(stock.map(s => s.number))].map(s => <option key={s} value={s} />)}
                      </datalist>
                  </div>

                  <div className="col-md-2">
                      <label className="form-label">Percentage (%)</label>
                      <div className="input-group">
                        <input className="form-control" placeholder="e.g. 50" value={form.percentage} onChange={e => setForm({...form, percentage: e.target.value})} list="pctOptions" required />
                        <span className="input-group-text">%</span>
                      </div>
                      <datalist id="pctOptions">
                          {[...new Set(stock.map(s => s.percentage))].map(q => <option key={q} value={q} />)}
                      </datalist>
                  </div>

                  <div className="col-md-2">
                      <label className="form-label">Pieces</label>
                      <input type="number" className="form-control fw-bold" value={form.quantity} onChange={e => setForm({...form, quantity: e.target.value})} required />
                  </div>
                  
                  <div className="col-md-3">
                      <label className="form-label">{form.type === 'IN' ? 'Vendor / Added By' : 'Worker Name'}</label>
                      <input type="text" className="form-control" value={form.personName} onChange={e => setForm({...form, personName: e.target.value})} required />
                  </div>

                  <div className="col-md-3">
                      <label className="form-label">Department</label>
                      <select className="form-select" value={form.department} onChange={e => setForm({...form, department: e.target.value})}>
                          {form.type === 'IN' ? <option value="Store">Store Room</option> : <><option value="Auto Bottom">Auto Bottom</option><option value="Autopel">Autopel</option></>}
                      </select>
                  </div>
              </div>
              <button className={`btn w-100 mt-3 fw-bold ${form.type === 'IN' ? 'btn-success' : 'btn-danger'}`}>
                  {form.type === 'IN' ? 'ADD TO STOCK' : 'CONFIRM ISSUE'}
              </button>
          </form>
      </div>

      {/* --- NEW: SEARCH FILTERS --- */}
      <div className="row g-2 mb-3 bg-light p-3 rounded border">
          <div className="col-md-1 d-flex align-items-center fw-bold text-muted">🔎 Filter:</div>
          <div className="col-md-3">
              <input type="text" className="form-control" placeholder="Search Number..." value={searchNum} onChange={e => setSearchNum(e.target.value)} />
          </div>
          <div className="col-md-3">
              <input type="text" className="form-control" placeholder="Search %..." value={searchPct} onChange={e => setSearchPct(e.target.value)} />
          </div>
          <div className="col-md-2">
              <button className="btn btn-outline-secondary w-100" onClick={() => { setSearchNum(''); setSearchPct(''); }}>Clear</button>
          </div>
      </div>

      {/* TABS */}
      <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
              <button className={`nav-link ${activeTab==='dashboard'?'active fw-bold':''}`} onClick={()=>setActiveTab('dashboard')}>📦 Stock Balance</button>
          </li>
          <li className="nav-item">
              <button className={`nav-link ${activeTab==='history'?'active fw-bold':''}`} onClick={()=>setActiveTab('history')}>📜 Transaction History</button>
          </li>
      </ul>

      {/* VIEW: STOCK DASHBOARD */}
      {activeTab === 'dashboard' && (
          <div className="row g-3">
              {filteredStock.length === 0 && <div className="text-center p-5 text-muted">No Items match your search.</div>}
              
              {filteredStock.map(item => (
                  <div key={item._id} className="col-md-3 col-sm-6" onClick={() => selectItem(item)} style={{cursor: 'pointer'}}>
                      <div className={`card h-100 shadow-sm border-${item.quantity < LOW_STOCK_LIMIT ? 'danger' : 'success'} border-2`}>
                          <div className={`card-header fw-bold text-center ${item.quantity < LOW_STOCK_LIMIT ? 'bg-danger text-white' : 'bg-light'}`}>
                              #{item.number} &mdash; {item.percentage}
                          </div>
                          <div className="card-body text-center">
                              <h2 className={`display-5 fw-bold ${item.quantity < LOW_STOCK_LIMIT ? 'text-danger' : 'text-success'}`}>
                                  {item.quantity}
                              </h2>
                              <div className="text-muted small">Pieces Available</div>
                              {item.quantity < LOW_STOCK_LIMIT && (
                                  <div className="badge bg-danger mt-2 blink_me">⚠️ LOW STOCK!</div>
                              )}
                          </div>
                      </div>
                  </div>
              ))}
          </div>
      )}

      {/* VIEW: HISTORY TABLE */}
      {activeTab === 'history' && (
          <div className="card shadow-sm">
              <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0 text-center">
                      <thead className="table-light">
                          <tr>
                              <th>Date</th>
                              <th>Type</th>
                              <th>Item (No / %)</th>
                              <th>Pieces</th>
                              <th>Person</th>
                              <th>Department</th>
                          </tr>
                      </thead>
                      <tbody>
                          {filteredHistory.map(h => (
                              <tr key={h._id}>
                                  <td>{new Date(h.date).toLocaleString()}</td>
                                  <td>
                                      <span className={`badge ${h.type==='IN' ? 'bg-success' : 'bg-danger'}`}>
                                          {h.type==='IN' ? 'IN (+)' : 'OUT (-)'}
                                      </span>
                                  </td>
                                  <td className="fw-bold">{h.diaId?.number} / {h.diaId?.percentage}</td>
                                  <td className="fw-bold">{h.quantity}</td>
                                  <td>{h.personName}</td>
                                  <td className="text-muted">{h.department}</td>
                              </tr>
                          ))}
                      </tbody>
                  </table>
              </div>
          </div>
      )}

    </div>
  );
};

export default AutoDept;